angular.module('dealerware.web.data').factory('DealerwareLocationOpenDayCollection', function ($q, Collection, DealerwareLocationOpenDayModel) {
    var collection = new Collection({
        baseEndpoint: '/locations/:location_id/open_days',
        model: 'DealerwareLocationOpenDayModel',
        customActions: {
            index: {
                method: 'GET',
                ignoreDefaultAssociationMapper: true
            },
            batch_update: {
                endpoint: '/locations/:location_id/open_days/batch_update',
                method: 'PUT',
                ignoreDefaultAssociationMapper: true
            }
        },
        requestTransforms: new function() {
            this.batch_update = function(args, data) {
                var originalData = $.extend(true, {}, data);
                var openDaysAttributes = {};
                $.each(originalData.open_days, function(k, openDay) {
                    openDaysAttributes[openDay.data.id] = {
                        id: openDay.data.id,
                        opening: openDay.data.opening,
                        closing: openDay.data.closing,
                        open: openDay.data.open
                    }
                });
                $.each(data, function(k,v) { delete data[k]; });
                $.extend(data, {
                    location_id: originalData.location_d,
                    open_days_attributes: openDaysAttributes
                });

            }
        }
    });

    return collection;
});
